<template>
	<v-dialog
		v-model="showDialog"
		max-width="1200px"
		:height="$vuetify.breakpoint.mdAndDown ? '100%' : '90%'"
		:fullscreen="$vuetify.breakpoint.mdAndDown ? true : false"
		:transition="$vuetify.breakpoint.mdAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-if="requiredDialogBtn" v-slot:activator="{ on, attrs }">
			<v-btn
				:text="text"
				:color="text ? 'white' : 'secondary'"
				class="ml-2"
				@click.stop="openDialog"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-plus</v-icon>
				依頼情報
			</v-btn>
		</template>

		<v-card tile :height="$vuetify.breakpoint.mdAndDown ? '100vh' : '90vh'" class="overflow-hidden">
			<v-app-bar
				dense
				dark
				flat
				color="primary"
				elevate-on-scroll
				scroll-target="#scrolling-techniques-4"
				extension-height="40px"
			>
				<v-app-bar-title class="color-white">依頼情報</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
				<template v-slot:extension>
					<v-tabs
						v-model="tab"
						height="40px"
						slider-color="primary"
						background-color="#f0f0f0"
						color="black"
						@change="selectTab"
					>
						<v-tab v-for="(item, i) in tabs" :key="i">
							{{ item.name }}
						</v-tab>
					</v-tabs>
				</template>
			</v-app-bar>
			<v-sheet
				elevation="0"
				id="scrolling-techniques-4"
				class="overflow-y-auto"
				:height="$vuetify.breakpoint.mdAndDown ? 'calc(100vh - 88px)' : 'calc(90vh - 88px)'"
			>
				<v-tabs-items v-model="tab" class="pa-2" @change="selectTab">
					<RequirementTab
						:requirement_data.sync="requirement"
						:isFetched="false"
						:requirementAuthorityFlag="requirementAuthorityFlag"
						@update-requirement="updateRequirement($event)"
						@update-requirement-values="updateRequirementValues($event)"
						@reload-index="$emit('reloadIndex')"
						@reload-requirement="openDialog($event)"
					/>
					<AnswerTab
						v-if="!hideAnswer"
						:requirement_data.sync="requirement"
						:answer_data.sync="answer"
						:isFetched="false"
						:answerAuthorityFlag="answerAuthorityFlag"
						@reload-answer="openDialog($event)"
						@update-answer="updateAnswer($event)"
					/>
					<RequirementFixesTab
						v-if="requirement.id != null"
						:requirement="requirement"
						:isFetched="false"
						:requirementAuthorityFlag="requirementAuthorityFlag"
					/>
					<AnswerFixesTab
						v-if="answer != null && answer.id != null && !hideAnswer"
						:answer="answer"
						:isFetched="false"
						:answerAuthorityFlag="answerAuthorityFlag"
					/>
					<MatterInfoTab
						v-if="requirement.matter"
						:matter_id="requirement.matter_id ? requirement.matter_id : null"
						:isFetched="isFetched('関連案件')"
					/>
				</v-tabs-items>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import _ from "lodash"
import RequirementTab from "./tabs/RequirementTab.vue"
import AnswerTab from "./tabs/AnswerTab.vue"
import RequirementFixesTab from "./tabs/RequirementFixesTab.vue"
import AnswerFixesTab from "./tabs/AnswerFixesTab.vue"
import MatterInfoTab from "./tabs/MatterInfoTab.vue"

export default {
	components: {
		RequirementTab,
		AnswerTab,
		RequirementFixesTab,
		AnswerFixesTab,
		MatterInfoTab,
	},
	props: {
		requiredDialogBtn: {
			type: Boolean,
			required: false,
			default: false,
		},
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		id: {
			type: Number,
			required: false,
			default: null,
		},
		firstTab: {
			type: String,
			required: false,
			default: "依頼",
		},
		hideAnswer: {
			type: Boolean,
			required: false,
			default: false,
		},
		syncDialog: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			tabs: [
				{ name: "依頼", isFetched: false },
				{ name: "回答", isFetched: false },
				{ name: "依頼修正履歴", isFetched: false },
				{ name: "回答修正履歴", isFetched: false },
			],
			tab: 0,
			requirementAuthorityFlag: false,
			answerAuthorityFlag: false,
			answer: null,
			requirement: {
				id: null,
				subtitle: "",
				requirement_type: {
					name: "",
				},
				user: {
					id: "",
					full_name: "",
					last_name: ",",
					first_name: "",
				},
				responder: {
					id: "",
					last_name: "",
					first_name: "",
				},
				requirement_fixes: [],
				requirement_values: [],
				matter: null,
				matter_product: null,
				ordered_product: null,
				order_individual_info: null,
			},
			common: common,
			text: Boolean,
			showIndex: Number,
		}
	},
	created() {
		if (this.hideAnswer) {
			this.tabs = [
				{ name: "依頼", isFetched: false },
				{ name: "依頼修正履歴", isFetched: false },
			]
		}
		const tab = this.tabs.find((t) => t.name == this.firstTab)
		this.tab = this.tabs.indexOf(tab)
	},
	methods: {
		selectTab(e) {
			this.tabs[e].isFetched = true
		},
		resetTabs() {
			this.tabs = this.hideAnswer
				? [
						{ name: "依頼", isFetched: false },
						{ name: "依頼修正履歴", isFetched: false },
				  ]
				: [
						{ name: "依頼", isFetched: false },
						{ name: "回答", isFetched: false },
						{ name: "依頼修正履歴", isFetched: false },
				  ]
			if (this.answer && !this.hideAnswer)
				this.tabs.push({ name: "回答修正履歴", isFetched: false })
		},
		openDialog(id, index) {
			this.tab = 0
			if (this.requirement.id == id) {
				this.showDialog = true
				return
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/requirement_values/" + id + ".json", {
					headers,
				})
				.then((res) => {
					this.requirement = res.data.requirement
					this.answer = res.data.answer
					this.requirementAuthorityFlag = res.data.requirement_authority_flag
					this.answerAuthorityFlag = res.data.answer_authority_flag
					this.resetTabs()
					if (res.data.requirement?.matter != null) {
						this.tabs.push({ name: "関連案件", isFetched: false })
					}
					this.showDialog = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateRequirement(requirement) {
			this.requirement = _.cloneDeep(requirement)
			this.$emit("update-requirement", this.requirement)
		},
		updateRequirementValues(requirement) {
			this.requirement = _.cloneDeep(requirement)
		},
		updateAnswer(answer) {
			this.answer = _.cloneDeep(answer)
		},
		closeDialog() {
			this.showDialog = false
			this.requirement = initialRequirement()
		},
	},
	computed: {
		isFetched() {
			return (name) => {
				const tab = this.tabs.find((t) => t.name == name)
				return tab != null ? tab.isFetched : false
			}
		},
		showDialog: {
			get() {
				return this.dialog
			},
			set(val) {
				if (this.syncDialog) {
					this.$emit("update:dialog", val)
				} else {
					this.dialog = val
				}
			},
		},
	},
	watch: {
		dialog(val) {
			if (val == true && this.id != null) {
				this.openDialog(this.id)
			}
		},
	},
}

function initialRequirement() {
	return {
		id: "",
		subtitle: "",
		requirement_type: {
			name: "",
		},
		user: {
			id: "",
			full_name: "",
			last_name: ",",
			first_name: "",
		},
		responder: {
			id: "",
			last_name: "",
			first_name: "",
		},
		requirement_fixes: [],
		requirement_values: [],
		matter: null,
		matter_product: null,
		ordered_product: null,
		order_individual_info: null,
	}
}
</script>

<style lang="scss">
.no-border {
	border: none;
}
.no-shadow {
	box-shadow: none;
}
.fs0875 {
	font-size: 0.875rem;
}
.btn-like {
	max-width: 256px;
	padding: 4px 8px;
	border: solid 1px gray;
	border-radius: 4px;
	cursor: pointer;
	box-shadow: 2px 2px 4px gray;
	&:active {
		box-shadow: none;
		margin-top: 2px;
		margin-left: 2px;
	}
}
.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
	color: black;
}
</style>
